var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"pr-badge",class:[_vm.data.class, _vm.data.staticClass]},[_c('span',[_vm._v(_vm._s(_vm.props.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }